// extracted by mini-css-extract-plugin
module.exports = {"QRCodeContent":"styles_QRCodeContent__33_L0","logo":"styles_logo__2mWLF","contentBox":"styles_contentBox__3yr_w","imageChangeAfter":"styles_imageChangeAfter__1_MVB"};